import withPermissionProtection from 'hoc/withPermissionProtection';
import { Switch, Route } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import TaxDocumentUpload from './TaxDocumentsUpload';
import RegistrationLogs from './RegistrationLogs';
import UserRegistration from './UserRegistration';
import IdLogs from './IdLogs';
import PlaidStatus from './PlaidStatus';
import Dashboard from './Dashboard';
import TaxDocuments from './TaxDocuments';
import EmployeeLookup from './EmployeeLookup';
import CCPA from './CCPA';
import HealthChecks from './HealthChecks';
import NotificationSender from './NotificationSender';

import useFeatureFlags from 'hooks/useFeatureFlags';

import AdminPermissions from 'constants/adminPermissions';
const FLAG_NOTIFICATION_BUILDER = 'MyCnC-NotificationBuilder';

const AdminHome = () => {
  const { isEnabled } = useFeatureFlags();
  return (
    <Grid container spacing={2} id="AdminHome">
      <Grid item xs={12}>
        <Switch>
          <Route
            path="/admin/taxdocumentsupload"
            exact={true}
            component={TaxDocumentUpload}
          />
          <Route
            path="/admin/taxdocuments"
            exact={true}
            component={TaxDocuments}
          />
          <Route
            path="/admin/registrationlogs"
            exact={true}
            component={RegistrationLogs}
          />
          <Route path="/admin/idlogs" exact={true} component={IdLogs} />
          <Route
            path="/admin/plaidstatus"
            exact={true}
            component={PlaidStatus}
          />
          <Route
            path="/admin/registration"
            exact={true}
            component={UserRegistration}
          />
          <Route
            path="/admin/employeelookup"
            exact={true}
            component={EmployeeLookup}
          />
          <Route path="/admin/ccpa" exact={true} component={CCPA} />
          <Route
            path="/admin/health-checks"
            exact={true}
            component={HealthChecks}
          />
          {isEnabled(FLAG_NOTIFICATION_BUILDER) && (
            <Route
              path="/admin/send-notifications"
              exact={true}
              component={NotificationSender}
            />
          )}
          <Route component={Dashboard} />
        </Switch>
      </Grid>
    </Grid>
  );
};

export default withPermissionProtection({
  permissions: [AdminPermissions],
  requireAccessToken: false,
})(AdminHome);
